"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDateFiltersCustomizer = void 0;
var tslib_1 = require("tslib");
var presentation_1 = require("../../presentation");
var ts_invariant_1 = require("ts-invariant");
var DefaultDateFilterRendererProvider = function () {
    return presentation_1.DefaultDashboardDateFilter;
};
var DefaultDateFiltersCustomizerState = /** @class */ (function () {
    function DefaultDateFiltersCustomizerState(defaultProvider) {
        var _this = this;
        /*
         * Core provider encapsulates resolution using the chain of core providers.
         */
        this.coreProvider = function (dateFilter) {
            var e_1, _a;
            var providerStack = tslib_1.__spread(_this.coreProviderChain).reverse();
            try {
                for (var providerStack_1 = tslib_1.__values(providerStack), providerStack_1_1 = providerStack_1.next(); !providerStack_1_1.done; providerStack_1_1 = providerStack_1.next()) {
                    var provider = providerStack_1_1.value;
                    var Component = provider(dateFilter);
                    if (Component) {
                        return Component;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (providerStack_1_1 && !providerStack_1_1.done && (_a = providerStack_1.return)) _a.call(providerStack_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // if this happens then the provider chain got messed up. by default the chain contains the default
            // provider which never returns undefined
            throw new ts_invariant_1.InvariantError();
        };
        /*
         * Root provider is THE provider that should be used in the dashboard extension properties. The
         * provider function included here will reflect the setup where there may be N registered decorators
         * sitting on top of a chain of core providers.
         *
         * In the initial state the root provider IS the core provider - meaning no decorations. As the
         * decorators get registered, the rootProvider changes.
         */
        this.rootProvider = this.coreProvider;
        this.coreProviderChain = [defaultProvider];
    }
    DefaultDateFiltersCustomizerState.prototype.addCustomProvider = function (provider) {
        this.coreProviderChain.push(provider);
    };
    DefaultDateFiltersCustomizerState.prototype.getRootProvider = function () {
        return this.rootProvider;
    };
    DefaultDateFiltersCustomizerState.prototype.switchRootProvider = function (provider) {
        this.rootProvider = provider;
    };
    return DefaultDateFiltersCustomizerState;
}());
/**
 * Sealed customizer state will not allow to perform any modifications of the state. Sealing the state
 * is essential to make the customization more defensive: during the registration, the plugin can hang
 * onto the dashboard customizer - stash it somewhere. And then after registration try to use the customizer
 * and try to do additional 'ad-hoc' customizations.
 *
 * Such a thing is not supported by the lifecycle and this sealing is in place to prevent plugins going into
 * that dangerous territory.
 */
var SealedDateFiltersCustomizerState = /** @class */ (function () {
    function SealedDateFiltersCustomizerState(logger, state) {
        var _this = this;
        this.logger = logger;
        this.state = state;
        this.addCustomProvider = function (_provider) {
            // eslint-disable-next-line no-console
            _this.logger.warn("Attempting to customize DateFilter rendering outside of plugin registration. Ignoring.");
        };
        // eslint-disable-next-line sonarjs/no-identical-functions
        this.switchRootProvider = function (_provider) {
            // eslint-disable-next-line no-console
            _this.logger.warn("Attempting to customize DateFilter rendering outside of plugin registration. Ignoring.");
        };
        this.getRootProvider = function () {
            return _this.state.getRootProvider();
        };
    }
    return SealedDateFiltersCustomizerState;
}());
/**
 * Default implementation of the DateFilter rendering customizer. Notice that the state of the customizations
 * is kept separate from this class.
 *
 * This code is responsible for creation of the providers (if needed) and then updating the state
 * accordingly. The customizer state methods are responsible for doing correct updates of the state itself. This
 * decoupling is in place so that it is possible to seal the state and prevent write operations from some point
 * onward. See {@link SealedDateFilterCustomizerState} for more motivation behind this.
 *
 * @internal
 */
var DefaultDateFiltersCustomizer = /** @class */ (function () {
    function DefaultDateFiltersCustomizer(logger, defaultProvider) {
        var _this = this;
        if (defaultProvider === void 0) { defaultProvider = DefaultDateFilterRendererProvider; }
        this.withCustomProvider = function (provider) {
            _this.state.addCustomProvider(provider);
            return _this;
        };
        this.getDateFilterProvider = function () {
            return _this.state.getRootProvider();
        };
        this.sealCustomizer = function () {
            _this.state = new SealedDateFiltersCustomizerState(_this.logger, _this.state);
        };
        this.logger = logger;
        this.state = new DefaultDateFiltersCustomizerState(defaultProvider);
    }
    return DefaultDateFiltersCustomizer;
}());
exports.DefaultDateFiltersCustomizer = DefaultDateFiltersCustomizer;
//# sourceMappingURL=dateFiltersCustomizer.js.map